import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { BrowserRouter as Router, Switch, Route, withRouter } from 'react-router-dom'
import {
  Home,
  AboutUs,
  Services,
  OurClients,
  Extract,
  Trckr,
  Books,
  Contact,
  Eula,
  SeoListing,
  WebDevelopment,
  AppDevelopment,
  DigitalMarketing,
  ExperientialMarketing,
  DataMining,
  UxUi
} from './pages'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-118276011-1 ')

class GAListener extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  }

  componentDidMount() {
    this.sendPageView(this.context.router.history.location)
    this.context.router.history.listen(this.sendPageView)
  }

  sendPageView(location) {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  }

  render() {
    return this.props.children
  }
}

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }
  render() {
    return this.props.children
  }
}
const RoutedScroll = withRouter(ScrollToTop)
const App = () => (
  <Router>
    <GAListener>
      <RoutedScroll>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={AboutUs} />
          <Route exact path="/seo-listing" component={SeoListing} />
          <Route exact path="/services" component={Services} />
          <Route exact path="/clients" component={OurClients} />
          <Route exact path="/extract" component={Extract} />
          <Route exact path="/eula" component={Eula} />
          <Route exact path="/trckr" component={Trckr} />
          <Route exact path="/books" component={Books} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/services/web-development" component={WebDevelopment} />
          <Route exact path="/services/app-development" component={AppDevelopment} />
          <Route exact path="/services/digital-marketing" component={DigitalMarketing} />
          <Route exact path="/services/experiential-marketing" component={ExperientialMarketing} />
          <Route exact path="/services/web-crawling" component={DataMining} />
          <Route exact path="/services/ux-ui" component={UxUi} />
        </Switch>
      </RoutedScroll>
    </GAListener>
  </Router>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js